import { Injectable } from '@angular/core';
import { RestProviderService } from '../rest-provider/rest-provider.service';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  add(key, value, persist = true) {
    if (persist) {
      localStorage.setItem(key, value);
    } else {
      sessionStorage.setItem(key, value);
    }
  }

  get(key) {
    var result = sessionStorage.getItem(key);
    if (result) {
      return result;
    }

    return localStorage.getItem(key);
  }

  remove(key) {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }

  compileKey(keys: string[]): string {
    let cacheKey: string = "";
    keys.forEach(el => {
      if (el) {
        cacheKey += el.toString().toLowerCase().trim() + ";";
      }
    });

    return cacheKey.substring(0, cacheKey.length - 1);
  }

  clear() {
    localStorage.clear();
    sessionStorage.clear();
  }
}
